export default __webpack_public_path__ + "static/media/toy12.cb80f67e.jfif";